import { render, staticRenderFns } from "./ElCheckbox.vue?vue&type=template&id=64e8c0ac&scoped=true&"
import script from "./ElCheckbox.vue?vue&type=script&lang=js&"
export * from "./ElCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ElCheckbox.vue?vue&type=style&index=0&id=64e8c0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8c0ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
